/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettingsService } from './app-settings.service';
import { DeviceService } from './device.service';
import { hd } from './helpdesk.typings';
import { HttpService } from './http.service';
import { IMCConnection } from './mc-connections/mc-connections.service';
import { TicketContextService } from './ticket-context.service';
import IDropdownList = hd.IDropdownList;
import IDropdownListItem = hd.IDropdownListItem;
import IActivityModel = hd.IActivityModel;
import { EmailAttachmentFile } from '../../apps/xsight/src/app/modules/ticket/ticket.model';
// temporary
type IDeviceModel = hd.IDeviceModel;

export interface ITagModel {
  /** The unique tag ID */
  tagId?: number;
  /** The associated tag title */
  title: string;
  /** The associated tagGroup Id */
  tagGroupId?: number;
  /**Tag color*/
  color?: string;
}

export interface ITagConfiguration {
  /** The user defined tag enabled configuration */
  isUserDefinedTagEnabled?: boolean;
  /** Indicating whether at least one pre-defined tag as required field in incident page is enabled or not */
  isPreDefinedTagRequired?: boolean;
}

export interface IRcConfiguration {
  /** Automatically create an incident when remotely controlling a device from MobiControl */
  autoCreationTicketEnabled: boolean;
}

export interface ILinkTicketModel {
  linkTicketId: number;
  linkType?: number;
  ticketId: number;
}

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  // Define the set of supported ticket statuses
  private ticketServiceStatusList: hd.IDropdownList = {
    draft: {
      id: 'draft',
      caption: 'ticketService_Status_Draft_Caption',
      glyphicon: 'hd-icon hd-icon-draft status-icon-draft',
    },
    open: {
      id: 'open',
      caption: 'ticketService_Status_Open_Caption',
      glyphicon: 'hd-icon hd-icon-open text-status-open status-icon-open',
    },
    pending: {
      id: 'pending',
      caption: 'ticketService_Status_Pending_Caption',
      glyphicon: 'hd-icon hd-icon-more status-icon-pending',
    },
    resolved: {
      id: 'resolved',
      caption: 'ticketService_Status_Resolved_Caption',
      glyphicon: 'hd-icon hd-icon-accept status-icon-resolved',
    },
  };

  // Define the set of supported ticket priorities
  private ticketPriorityList: hd.IDropdownList = {
    blocker: {
      id: 'blocker',
      caption: 'ticketService_Priority_Blocker_Caption',
      glyphicon: 'hd-icon hd-icon-blocker priority-icon-blocker',
    },
    critical: {
      id: 'critical',
      caption: 'ticketService_Priority_Critical_Caption',
      glyphicon: 'hd-icon hd-icon-critical priority-icon-critical',
    },
    major: {
      id: 'major',
      caption: 'ticketService_Priority_Major_Caption',
      glyphicon: 'hd-icon hd-icon-major priority-icon-major',
    },
    minor: {
      id: 'minor',
      caption: 'ticketService_Priority_Minor_Caption',
      glyphicon: 'hd-icon hd-icon-minor priority-icon-minor',
    },
    low: {
      id: 'low',
      caption: 'ticketService_Priority_Low_Caption',
      glyphicon: 'hd-icon hd-icon-low priority-icon-low',
    },
  };

  // Define the set of supported ticket reported methods
  private ticketReportedMethodList: hd.IDropdownList = {
    phone: {
      id: 'phone',
      caption: 'ticketService_ReportedMethod_Phone_Caption',
      icon: 'reported-method-phone.svg',
    },
    email: {
      id: 'email',
      caption: 'ticketService_ReportedMethod_Email_Caption',
      icon: 'reported-method-email.svg',
    },
    chat: {
      id: 'chat',
      caption: 'ticketService_ReportedMethod_Chat_Caption',
      icon: 'reported-method-chat.svg',
    },
    selfservice: {
      id: 'selfservice',
      caption: 'ticketService_ReportedMethod_SelfService_Caption',
      icon: 'reported-method-selfservice.svg',
    },
    connect: {
      id: 'connect',
      caption: 'ticketService_ReportedMethod_Connect_Caption',
      icon: 'reported-method-connect.svg',
    },
  };

  // Define the set of supported ticket association types
  private ticketAssociationTypeList: hd.IDropdownList = {
    related: {
      id: 'related',
      caption: 'ticketService_Association_Related_Caption',
      glyphicon: 'hd-icon hd-icon-linked icon-md',
    },
    blockedby: {
      id: 'blockedby',
      caption: 'ticketService_Association_BlockedBy_Caption',
      glyphicon: 'hd-icon hd-icon-blocked icon-md icon-red',
    },
    blocking: {
      id: 'blocking',
      caption: 'ticketService_Association_Blocking_Caption',
      glyphicon: 'hd-icon hd-icon-blocking icon-md icon-red',
    },
    resolves: {
      id: 'resolves',
      caption: 'ticketService_Association_Resolves_Caption',
      glyphicon: 'hd-icon hd-icon-addressed icon-md icon-green',
    },
    resolvedby: {
      id: 'resolvedby',
      caption: 'ticketService_Association_ResolvedBy_Caption',
      glyphicon: 'hd-icon hd-icon-addressing icon-md icon-green',
    },
  };

  constructor(private http: HttpService, private appSettings: AppSettingsService, private xsi18n: XsI18nPipe) {}

  getTicket(ticketId: string): Observable<hd.ITicketModel> {
    return this.http.get(this.appSettings.ticketServiceUrl + ticketId).pipe(
      map((response: any) => {
        const ticket = response as hd.ITicketModel;
        ticket.allowableActions = response.allowableActions ? response.allowableActions.split(',') : [];
        ticket.status ||= 'draft';
        return ticket;
      })
    );
  }

  /** Puts ticket object */
  putTicket(ticketId: string, property: string, value: any, note: string): Observable<hd.ITicketModel> {
    return this.http.put<hd.ITicketModel>(this.appSettings.ticketServiceUrl + `${ticketId}/${property}`, {
      ticketId,
      property,
      value,
      note,
    });
  }

  /**Sets ticket to isDeleted**/
  deleteTicket(ticketId: string): Observable<hd.ITicketModel> {
    return this.http.delete<hd.ITicketModel>(this.appSettings.ticketServiceUrl + `${ticketId}`);
  }

  // /** Gets the tag list */
  // public getTagList = (): Observable<ITagModel[]> => {
  //   return this.http.get<ITagModel[]>(this.appSettings.ticketServiceUrl + 'tags');
  // };
  //
  // /** Gets the tag group list */
  // public getTagGroupList = (): Observable<hd.ITagGroupModel[]> => {
  //   return this.http.get<hd.ITagGroupModel[]>(this.appSettings.ticketServiceUrl + 'tags/groups');
  // };

  /** Gets the tag list based on ticketIds */
  public getTicketIdsTagList(ticketIds: string[]): Observable<{ [key: string]: ITagModel[] }> {
    return this.http.post<{ [key: string]: ITagModel[] }>(
      this.appSettings.ticketServiceUrl + 'tags/associations',
      ticketIds
    );
  }

  /** @see ITicketService.getAssociatedTagsResource */
  public getAssociatedTicketTags = (ticketId: string): Observable<hd.IAssociatedTagModel> => {
    return this.http.get<hd.IAssociatedTagModel>(`${this.appSettings.ticketServiceUrl}${ticketId}/tags/`);
  };

  /** @see ITicketService.getAssociatedTicketsTagsResource */
  public getAssociatedTicketsTags = (ticketList: any): Observable<{ [key: string]: hd.IAssociatedTagModel[] }> => {
    const resource = this.http.post<{ [key: string]: hd.IAssociatedTagModel[] }>(
      this.appSettings.ticketServiceUrl + 'tags/associations',
      ticketList
    );
    return resource;
  };

  /** Gets the device list based on ticketId */
  public getAssociatedDevices(ticketId: string): Observable<hd.IAssociatedDeviceModel[]> {
    return this.http.get<hd.IAssociatedDeviceModel[]>(this.appSettings.ticketServiceUrl + ticketId + '/devices/');
  }

  public createAssociatedDevice(deviceAssociation: hd.IAssociatedDeviceModel): Observable<number> {
    return this.http.post<number>(
      this.appSettings.ticketServiceUrl + deviceAssociation.ticketId + '/devices/',
      deviceAssociation
    );
  }

  public removeAssociatedDevice(deviceAssociation: hd.IAssociatedDeviceModel): Observable<void> {
    return this.http.delete<void>(
      this.appSettings.ticketServiceUrl + deviceAssociation.ticketId + '/devices/' + deviceAssociation.deviceId
    );
  }

  /** Gets the tag list based on ticketId */
  public getTicketTagList(ticketId: string): Observable<ITagModel[]> {
    return this.http.get<ITagModel[]>(this.appSettings.ticketServiceUrl + `${ticketId}/tags`);
  }

  /** Delete a tag association */
  public deleteTagAssociation = (ticketId: number, tagId: number): Observable<void> => {
    return this.http.delete(this.appSettings.ticketServiceUrl + `${ticketId}/tags/${tagId}`);
  };

  /** Add a tag association */
  public addTagAssociation = (ticketId: number, tagId: number): Observable<void> => {
    return this.http.post(this.appSettings.ticketServiceUrl + `${ticketId}/tags/${tagId}`, null);
  };

  /** Add a tag */
  public searchTags = (searchText: string): Observable<ITagModel[]> => {
    return this.http.get(this.appSettings.ticketServiceUrl + `tags?searchText=` + searchText);
  };

  /** Add a tag */
  public createTag = (value: ITagModel): Observable<ITagModel> => {
    return this.http.post<ITagModel>(this.appSettings.ticketServiceUrl + 'tags', value);
  };

  /** Delete a tag */
  public deleteTag = (tagId: number): Observable<void> => {
    return this.http.delete(this.appSettings.ticketServiceUrl + `tags/${tagId}`);
  };

  /** Associate device to ticket */
  public getConnections = (): Observable<IMCConnection[]> => {
    return this.http.get<IMCConnection[]>(this.appSettings.accountServiceUrl + 'connections');
  };

  public getTicketStatus = (statusId: string): hd.IDropdownList | hd.IDropdownListItem => {
    return this.getFromKeyIdCaptionList(this.ticketServiceStatusList, 'ticketServiceStatusList', statusId);
  };

  // Generic list query function.  Either returns the value matching the id, the list or undefined if the value does not exist.
  private getFromKeyIdCaptionList = (
    list: hd.IDropdownList,
    listName: string,
    id: string
  ): hd.IDropdownList | hd.IDropdownListItem => {
    if (!id) {
      // If no status id was specified, return the full list
      return list;
    }
    const value = list[id];
    if (!value) {
      console.log('No value found in ' + listName + ' for id: ' + id);
    }
    return value;
  };

  /** @see ITicketService.getTicketPriority */
  public getTicketPriority = (priorityId: string): hd.IDropdownList | hd.IDropdownListItem => {
    return this.getFromKeyIdCaptionList(this.ticketPriorityList, 'ticketPriorityList', priorityId);
  };

  /** @see ITicketService.getTicketReportedMethod */
  public getTicketReportedMethod = (reportedMethodId: string): hd.IDropdownList | hd.IDropdownListItem => {
    return this.getFromKeyIdCaptionList(this.ticketReportedMethodList, 'ticketReportedMethodList', reportedMethodId);
  };

  public getTicketUserConfiguration = (): Observable<hd.ITicketUserConfiguration> => {
    return this.http.get<hd.ITicketUserConfiguration>(
      this.appSettings.ticketServiceUrl + 'config/ticketUserConfiguration'
    );
  };

  /** @see ITicketService.getTicketWork */
  public getTicketWork = (ticketId: string): Observable<hd.ITicketWorkInfoModel> => {
    const resource = this.http.get<hd.ITicketWorkInfoModel>(this.appSettings.ticketServiceUrl + ticketId + '/work/');
    return resource;
  };

  public createChildActivity = (ticketId: string, childActivity: hd.IActivityModel): Observable<hd.IActivityModel> => {
    return this.http.post<hd.IActivityModel>(this.getTicketActivitiesUrl(ticketId), childActivity);
  };

  public createTicket = (value: hd.IDraftXSightTicketModel): Observable<hd.ITicketModel> => {
    // value.reporterPublicId = this.user
    return this.http.post<hd.ITicketModel>(this.appSettings.ticketServiceUrl + 'create', value);
  };

  public createSppTicket = (value: hd.IDraftXSightTicketModel): Observable<hd.ITicketModel> => {
    return this.http.post<hd.ITicketModel>(this.appSettings.ticketServiceUrl + 'create/ssp', value);
  };

  // /** @see ITicketService.getTicketActivitiesUrl */
  public getTicketActivitiesUrl = (ticketId?: string): string => {
    if (ticketId) {
      return this.appSettings.ticketServiceUrl + ticketId + '/activities/';
    } else {
      return this.appSettings.activityServiceUrl;
    }
  };

  // /** @see ITicketService.getTicketAttachmentUrl */
  public getTicketAttachmentUrl = (ticketId?: string): string => {
    if (ticketId) {
      return this.appSettings.ticketServiceUrl + ticketId + '/attachment/';
    } else {
      return this.appSettings.ticketServiceUrl + '-1/attachment/';
    }
  };

  /** @see ITicketService.getAssociatedTagsResource */
  public getAssociatedTags = (ticketId: string): Observable<hd.IAssociatedTagModel[]> => {
    return this.http.get<hd.IAssociatedTagModel[]>(`${this.appSettings.ticketServiceUrl}${ticketId}/tags/`);
  };

  public getAssociatedTickets(ticketId: string): Observable<ILinkTicketModel[]> {
    return this.http.get<ILinkTicketModel[]>(this.appSettings.ticketServiceUrl + ticketId + '/tickets/');
  }

  public getTicketList(ticketIds: string[]): Observable<hd.ITicketModel[]> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('ticketIds', ticketIds.toString());
    return this.http.get<hd.ITicketModel[]>(this.appSettings.ticketServiceUrl, { params: queryParams });
  }

  /** @see ITicketService.getTicketAssociationType */
  public getTicketAssociationType = (associationType: string): IDropdownList | IDropdownListItem => {
    return this.getFromKeyIdCaptionList(this.ticketAssociationTypeList, 'ticketAssociationTypeList', associationType);
  };

  postTicketAssociation(ticketId: number, associationTicket: string) {
    return this.http.post<number>(`${this.appSettings.ticketServiceUrl}link/`, {
      linkTicketId: associationTicket,
      linkType: 1,
      ticketId: ticketId,
    });
  }

  deleteTicketAssociation(ticketId: number, associationId: number) {
    return this.http.post<number>(`${this.appSettings.ticketServiceUrl}unlink/`, {
      linkTicketId: associationId,
      ticketId: ticketId,
    });
  }

  updateTicketAssociation(ticketId: number, associationId: number, typeId: number) {
    return this.http.post<number>(`${this.appSettings.ticketServiceUrl}link/`, {
      linkTicketId: associationId,
      linkType: typeId,
      ticketId: ticketId,
    });
  }

  submitTicket(ticketId: number, status: string) {
    return this.http.post<number>(this.appSettings.ticketServiceUrl + `${ticketId}/submit/${status}`, null);
  }

  updateTicket(ticketId: number, ticketData: hd.IUpdateParams[]) {
    return this.http.put<hd.ITicketModel>(this.appSettings.ticketServiceUrl + 'update', {
      ticketId: ticketId,
      ticketData: JSON.stringify(ticketData),
    });
  }

  public saveActivity(activity: IActivityModel, ticketId: string, shouldSendEmail:boolean = true): Observable<IActivityModel> {    
    return this.http.post<IActivityModel>(this.appSettings.ticketServiceUrl
      + `${ticketId}/activities?emailNotification=${shouldSendEmail}`, activity);
  }

  public getActivity(ticketId: number, activityId: number): Observable<IActivityModel> {
    return this.http.get<IActivityModel>(this.appSettings.ticketServiceUrl + `${ticketId}/activities/${activityId}`);
  }
  public attachFileToEmail(activityId: number, attachment: EmailAttachmentFile): Observable<string> {
    return this.http.post<string>(
      this.appSettings.ticketServiceUrl + `activities/${activityId}/attachEmailFile`,
      attachment
    );
  }

  public getEmailAttachmentFiles(activityId: number): Observable<EmailAttachmentFile[]> {
    return this.http.get<EmailAttachmentFile[]>(
      this.appSettings.ticketServiceUrl + `activities/${activityId}/emailAttachmentFiles`
    );
  }

  public deleteEmailAttachmentFile(activityId: number, fileId: string): Observable<string> {
    return this.http.delete<string>(
      this.appSettings.ticketServiceUrl + `activities/${activityId}/deleteEmailAttachment/${fileId}`
    );
  }

  public getActivities(ticketId: number): Observable<IActivityModel> {
    return this.http.get<IActivityModel>(this.appSettings.ticketServiceUrl + `${ticketId}/activities`);
  }

  public deleteActivity(activityId: number, ticketId: string): Observable<boolean> {
    return this.http.delete(this.appSettings.ticketServiceUrl + `${ticketId}/activities/${activityId}`);
  }

  /** @see ITicketService.associateWithNewTicket  */
  public associateWithNewTicket = (deviceId: any, ticketTemplate: any): Observable<hd.ITicketModel> => {
    if (!ticketTemplate) {
      ticketTemplate = {} as hd.ITicketModel;
    }

    // Attempt to create a new ticket with the current device associated
    const newTicket = Object.assign(ticketTemplate, { associatedDeviceIds: [deviceId] });
    return this.http.post<hd.ITicketModel>(this.appSettings.ticketServiceUrl + 'create', newTicket);
  };

  /** @see ITicketService.associateWithExistingTicket  */
  public associateWithExistingTicket = (deviceId: any, ticketTemplate: any): Observable<hd.ITicketModel> => {
    const observable = new Observable<hd.ITicketModel>(subscriber => {
      const ticketId = ticketTemplate.ticketId;
      // Query existing device associations for specified ticket
      this.getTicket(ticketId).subscribe(
        (/* ticket: any */) => {
          // const associatedDevices = ticket.devices ? ticket.devices : [];
          // Is the current device already associated with this ticket?
          // let alreadyAssociated = false;
          // for (let i = 0; i < associatedDevices.length; ++i) {
          //   if (associatedDevices[i].deviceId === deviceId) {
          // alreadyAssociated = true;
          //   break;
          // }
          // }

          // TODO: Shouldn't we actually associate something here? - Werner

          subscriber.next(ticketTemplate);
        },
        (err: hd.IError) => {
          console.error('Failed to query current device associations for ticket ' + ticketTemplate.ticketId);
          subscriber.error(err);
        }
      );
    });

    return observable;
  };

  public getReportersResource = (reporterPublicId: string): Observable<hd.IResourceClass<hd.ITicketModel>> => {
    return this.http.get<hd.IResourceClass<hd.ITicketModel>>(this.appSettings.ticketServiceUrl);
  };
}
